import { Injectable } from '@angular/core';
import { from, map } from 'rxjs';
import {
  ReportingComparisonDatasetSelections,
  type ReportingComparisonHttpQuery,
  type ReportingComparisonResponseDto,
} from 'ag-common-lib/lib/contracts/reporting-api.contracts';
import { ReportingApiService } from '../../../services/reporting-api.service';

@Injectable()
export class ProductionComparisonReportService {
  private static readonly comparisonReportPath = '/api/reports/comparison';

  constructor(private readonly reportingApiService: ReportingApiService) {}

  getComparisonReport(query: ReportingComparisonHttpQuery) {
    return from(
      this.reportingApiService.request<ReportingComparisonResponseDto>(
        ProductionComparisonReportService.comparisonReportPath,
        {
          method: 'GET',
          query,
        },
      ),
    ).pipe(map(response => this.filterDatasetsIfNeeded(response, query.dataset_selection)));
  }

  private filterDatasetsIfNeeded(
    response: ReportingComparisonResponseDto,
    datasetSelection?: ReportingComparisonHttpQuery['dataset_selection'],
  ): ReportingComparisonResponseDto {
    if (!datasetSelection || datasetSelection === ReportingComparisonDatasetSelections.all) {
      return response;
    }

    if (datasetSelection === ReportingComparisonDatasetSelections.paid) {
      return {
        ...response,
        submit: {
          ...response.submit,
          topIncreases: [],
          topDecreases: [],
          ranking: [],
          trend: [],
          allMgaRows: [],
          allAgentRows: [],
        },
      };
    }

    return {
      ...response,
      paid: {
        ...response.paid,
        topIncreases: [],
        topDecreases: [],
        ranking: [],
        trend: [],
        allMgaRows: [],
        allAgentRows: [],
      },
    };
  }
}
